export default __webpack_public_path__ + "static/media/azienda-main-img.aa731a26.jpg";